import { singletonInstanceSummoner } from '../singletonInstanceSummoner'

/**
 * # $core.$dict (Deprecated)
 *
 * @deprecated このサービスは非推奨です。代わりに `$core.$i18n.i18nInstance.t()` または Vue コンポーネント内の `useTranslation()` / `$t` を使用してください。互換性のために残されていますが、将来的に削除される可能性があります。
 *
 * - COREアプリケーション内各所のテキスト表記を管理するための互換レイヤー。
 * - 内部的に `$core.$i18n` サービスを利用して動作します。
 *
 * @category $core/40.customize/403.dict
 */
export class DictionaryService {
  /**
   * 指定されたキーに対応する翻訳を取得します。
   * `$core.$i18n` が初期化されていない場合は、`fallbackContent` を返します。
   *
   * @deprecated 代わりに `$core.$i18n.i18nInstance.t(key, { defaultValue: fallbackContent })` を使用してください。
   * @param key 翻訳キー
   * @param fallbackContent キーが見つからない場合のデフォルト値 (デフォルトはキー自身)
   * @returns 翻訳された文字列、またはフォールバック文字列
   */
  get(key: string, fallbackContent: string = key): string {
    // $core と $i18n が利用可能かつ初期化済みかチェック
    if (!$core?.$i18n?.isInitialized) {
      // console.warn('[Deprecated $dict.get] $core.$i18n is not initialized. Returning fallback.');
      return fallbackContent
    }
    try {
      // i18next インスタンスの t 関数を利用
      return $core.$i18n.i18nInstance.t(key, { defaultValue: fallbackContent })
    } catch (error) {
      console.error(
        `[Deprecated $dict.get] Error during translation for key "${key}":`,
        error,
      )
      return fallbackContent // エラー時もフォールバック
    }
  }

  /**
   * 現在の言語に対して、指定されたキーの翻訳を設定（上書き）します。
   * `$core.$i18n` が初期化されていない場合は警告を出力します。
   *
   * @deprecated 代わりに `$core.$i18n.addOrUpdateTranslations(currentLanguage, { [key]: value })` を使用してください。
   * @param key 設定する翻訳キー
   * @param value 設定する翻訳文字列
   */
  set(key: string, value: string): void {
    if (!$core?.$i18n?.isInitialized) {
      console.warn(
        '[Deprecated $dict.set] $core.$i18n is not initialized. Cannot set translation.',
      )
      return
    }
    try {
      const currentLanguage = $core.$i18n.i18nInstance.language
      if (!currentLanguage) {
        console.warn('[Deprecated $dict.set] Cannot determine current language.')
        return
      }
      // addOrUpdateTranslations を利用して現在の言語にリソースを追加/更新
      $core.$i18n.addOrUpdateTranslations(currentLanguage, { [key]: value })
    } catch (error) {
      console.error(
        `[Deprecated $dict.set] Error setting translation for key "${key}":`,
        error,
      )
    }
  }

  /**
   * 現在の言語に対して、複数の翻訳を一括で設定（上書き）します。
   * `$core.$i18n` が初期化されていない場合は警告を出力します。
   *
   * @deprecated 代わりに `$core.$i18n.addOrUpdateTranslations(currentLanguage, dictionary)` を使用してください。
   * @param dictionary 設定する翻訳キーと値のオブジェクト
   */
  configure(dictionary: { [keyName: string]: string }): void {
    if (!$core?.$i18n?.isInitialized) {
      console.warn(
        '[Deprecated $dict.configure] $core.$i18n is not initialized. Cannot configure translations.',
      )
      return
    }
    try {
      const currentLanguage = $core.$i18n.i18nInstance.language
      if (!currentLanguage) {
        console.warn('[Deprecated $dict.configure] Cannot determine current language.')
        return
      }
      // addOrUpdateTranslations を利用して現在の言語にリソースを追加/更新
      $core.$i18n.addOrUpdateTranslations(currentLanguage, dictionary)
    } catch (error) {
      console.error(`[Deprecated $dict.configure] Error configuring translations:`, error)
    }
  }

  /**
   * `configure` メソッドのエイリアス。
   * @deprecated 代わりに `configure` または `$core.$i18n.addOrUpdateTranslations` を使用してください。
   */
  get bulkSet() {
    return this.configure
  }

  /**
   * シングルトンインスタンスを取得します。
   * @internal
   */
  static get instance(): DictionaryService {
    // シングルトンインスタンスの取得方法は維持
    return singletonInstanceSummoner<DictionaryService>(
      'DictionaryService',
      DictionaryService,
    )
  }
}

/**
 * DictionaryService のシングルトンインスタンス。
 * @deprecated `$core.$dict` は非推奨です。代わりに `$core.$i18n` または `useTranslation` を使用してください。
 */
export const $dict = DictionaryService.instance
